import Vue from 'vue';
import { breakpoints } from '@superbet-group/web.lib.vue-utilities';

var script = Vue.extend({
    name: 'ImageSetPicture',
    props: {
        srcSet: {
            type: Object,
            required: true,
        },
        alt: {
            type: String,
            required: false,
        },
    },
    created: function () {
        this.largeBreakpoint = breakpoints.tXl;
        this.smallBreakpoint = breakpoints.tSm;
    },
});

export default script;
